// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { FormattedMessage } from 'react-intl';
import { Desktop, Mobile, Tablet } from '../../../../utils/responsive';
import Slider from 'react-slick/lib';
import Arrow from '../../../../elements/Arrow/Arrow';

import style from './CarouselPressNew.scss';
import icons from '../../../../assets/styles/icons.scss';

import forbes from '../../../../assets/img/new-order/scrap-step/press/01_Forbes.png';
import elcomercio from '../../../../assets/img/new-order/scrap-step/press/06_elcomercio.png';
import mit from '../../../../assets/img/new-order/scrap-step/press/03_MIT.png';
import venturecity from '../../../../assets/img/new-order/scrap-step/press/11_venture.png';
import entrepreneur from '../../../../assets/img/new-order/scrap-step/press/02_Entrepreneur.png';
import publimetro from '../../../../assets/img/new-order/scrap-step/press/08_publimetro.png';
import peru21 from '../../../../assets/img/new-order/scrap-step/press/07_peru21.png';
import tvperu from '../../../../assets/img/new-order/scrap-step/press/05_tvperu.png';

import trome from '../../../../assets/img/new-order/scrap-step/press/Trome.png';
import americatv from '../../../../assets/img/new-order/scrap-step/press/America.png';
import larazon from '../../../../assets/img/new-order/scrap-step/press/La razon.png';
import visanet from '../../../../assets/img/new-order/scrap-step/press/Visanet.png';
import bluradio from '../../../../assets/img/new-order/scrap-step/press/blueradio.png';
import el_espectador from '../../../../assets/img/new-order/scrap-step/press/el_espectador.png';
import la_republica from '../../../../assets/img/new-order/scrap-step/press/republica.png';
import dinners from '../../../../assets/img/new-order/scrap-step/press/diners.png';

import type { Element } from 'react';
import type { LocaleState } from '../../../locale/duck';

type Press = {
  image: string;
  url: string;
};

type Props = {
  +locale: LocaleState;
};

type State = {
  lightningRightArrow: boolean;
  lightningLeftArrow: boolean;
};

const press = {
  PE: [
    { image: forbes, url: 'https://www.forbes.com.mx/mit-premia-a-los-35-mas-innovadores-de-latinoamerica/' },
    {
      image: elcomercio,
      url: 'https://elcomercio.pe/especial/zona-ejecutiva/actualidad/qempo-acelerador-que-busca-potenciar-commerce-peru-noticia-1993504',
    },
    {
      image: mit,
      url: 'https://www.technologyreview.es/listas/35-innovadores-con-menos-de-35/2017/emprendedores/anson-tou-peru',
    },
    {
      image: venturecity,
      url: 'https://medium.com/theventurecity/qempo-los-mejores-productos-sin-fronteras-ca8de7fd17e8',
    },
    {
      image: trome,
      url: 'https://trome.pe/emprende-trome/qempo-empezo-jugando-emprende-trome-fotos-video-entrevista-98378',
    },
    {
      image: americatv,
      url: 'https://www.americatv.com.pe/noticias/actualidad/quempo-historia-jovenes-peruanos-que-crearon-empresas-mas-exitosas-n331434',
    },
    { image: entrepreneur, url: 'https://www.entrepreneur.com/article/305194' },
    { image: publimetro, url: 'https://publimetro.pe/actualidad/noticia-qempo-solucion-comprar-fuera-peru-76400' },
    { image: peru21, url: 'https://peru21.pe/economia/qempo-preve-cerrar-ano-s-3-millones-ventas-413855' },
    {
      image: larazon,
      url: 'https://www.larazon.es/hablemos-de-futuro/qempo-com-compra-por-todo-el-mundo-y-gana-dinero-viajando-HN19726436',
    },
    { image: visanet, url: 'https://www.visanet.com.pe/noticias/Concursoseedstarsenlima' },
    { image: tvperu, url: 'https://www.tvperu.gob.pe/noticias/tecnologia/qempo-la-exitosa-web-de-compras-online' },
  ],
  CO: [
    {
      image: bluradio,
      url: 'https://www.bluradio.com/sociedad/qempo-el-emprendimiento-que-conecta-compradores-con-viajeros-250819-ie430',
    },
    {
      image: el_espectador,
      url: 'https://www.elespectador.com/cromos/estilo-de-vida/hacer-compras-en-el-exterior-ahora-es-facil-y-rapido',
    },
    {
      image: la_republica,
      url: 'https://www.larepublica.co/internet-economy/qempo-llegara-a-brasil-este-ano-y-preve-entrar-al-mercado-de-argentina-en-2020-2914978',
    },
    {
      image: dinners,
      url: 'https://revistadiners.com.co/estilo-de-vida/72894_3-ideas-de-jovenes-emprendedores-colombianos-reconocidas-internacionalmente/',
    },
    { image: forbes, url: 'https://www.forbes.com.mx/mit-premia-a-los-35-mas-innovadores-de-latinoamerica/' },
    {
      image: mit,
      url: 'https://www.technologyreview.es/listas/35-innovadores-con-menos-de-35/2017/emprendedores/anson-tou-peru',
    },
    {
      image: venturecity,
      url: 'https://medium.com/theventurecity/qempo-los-mejores-productos-sin-fronteras-ca8de7fd17e8',
    },
    { image: entrepreneur, url: 'https://www.entrepreneur.com/article/305194' },
    {
      image: larazon,
      url: 'https://www.larazon.es/hablemos-de-futuro/qempo-com-compra-por-todo-el-mundo-y-gana-dinero-viajando-HN19726436',
    },
    { image: publimetro, url: 'https://publimetro.pe/actualidad/noticia-qempo-solucion-comprar-fuera-peru-76400' },
  ],
};

export default class CarouselPressNew extends Component<Props, State> {
  state = {
    lightningRightArrow: false,
    lightningLeftArrow: true,
  };

  handleArrowStyle(current: number, lastIndex: number) {
    const lightningLeftArrow = current === 0;
    const lightningRightArrow = current === lastIndex;
    this.setState({ lightningLeftArrow, lightningRightArrow });
  }

  buildBoxes = (): Element<'a'>[] => {
    const { locale } = this.props;
    const localizedPress = press[locale.domainCountry || 'PE'] || press['PE'];
    return localizedPress.map((item: Press, n: number) =>
      (<a key={n} href={item.url} target="_blank">
        <section>
          <img src={item.image}
               alt="Qempo"/>
        </section>
      </a>));
  };

  render() {
    const { lightningRightArrow, lightningLeftArrow } = this.state;
    const items = this.buildBoxes();

    const options = {
      infinite: false,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      draggable: true,
      nextArrow: <Arrow icon={icons.iconChevronRightMedium}
                        positionClass={style.arrowRight}
                        visible={lightningRightArrow}/>,
      prevArrow: <Arrow icon={icons.iconChevronLeftMedium}
                        positionClass={style.arrowLeft}
                        visible={lightningLeftArrow}/>,
    };

    const mobileSettings = {
      ...options,
      slidesToShow: 2,
      afterChange: (current) => this.handleArrowStyle(current, 7),
    };
    const tableSettings = {
      ...options,
      slidesToShow: 5,
      afterChange: (current) => this.handleArrowStyle(current, 6),
    };
    const desktopSettings = {
      ...options,
      slidesToShow: 7,
      afterChange: (current) => this.handleArrowStyle(current, 4),
    };

    return (
      <section className={style.carouselImages}>
        <FormattedMessage id="home.press.title">{
          text => <h2>{text}</h2>
        }</FormattedMessage>
        <section className={style.carousel}>
          <Mobile>
            <Slider {...mobileSettings}>
              {items}
            </Slider>
          </Mobile>
          <Tablet>
            <Slider {...tableSettings}>
              {items}
            </Slider>
          </Tablet>
          <Desktop>
            <Slider {...desktopSettings}>
              {items}
            </Slider>
          </Desktop>
        </section>
      </section>);
  }
}

CarouselPressNew.propTypes = {
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/home/components/CarouselPressNew/CarouselPressNew.jsx